module.exports = __webpack_public_path__ + "img/damage_detail.d554fbc2.png";